import React from 'react';
import { Timeline, Spin } from 'antd';
import { CheckCircleFilled, ExclamationCircleFilled, StopFilled, SyncOutlined } from '@ant-design/icons';
import moment from 'moment';

import { useProgressCollection } from '../../models/useProgressCollection';
import { usePayoutDetails } from '../../models/usePayoutDetails';
import { useWithdrawalDetails } from '../../models/useWithdrawalDetails';

export const ProgressListView = ({ progressCollection, item, isPendingCallback, shouldUseDate, isAdmin = false }) => {

  const isPending = () => {
    if(isPendingCallback) { return isPendingCallback(item); }

    if (item.status) {
      return ['created', 'ready', 'validated', 'connecting', 'waiting', 'api_requested', 'processing'].includes(item.status);
    }
    return false;
  };

  const dotColor = (progress) => {
    const { type } = progress || {};
    switch (type) {
      case 'info':
        return 'blue';
      case 'warn':
        return 'orange';
      case 'success':
        return 'green';
      case 'fail':
        return 'red';
    }
    return 'blue';
  };

  const dotIcon = (progress, spin) => {
    const { type } = progress || {};
    switch (type) {
      case 'warn':
        return <ExclamationCircleFilled />;
      case 'success':
        return <CheckCircleFilled />;
      case 'fail':
        return <StopFilled />;
    }
    return spin ? <SyncOutlined spin /> : null;
  };

  const isSpin = (index) => {
    return progressCollection && ((progressCollection.length - 1) === index) && isPending();
  }

  const useDate = (element) => {
    if(!shouldUseDate) { return ''; }
    const { createdAt } = element || { }; 
    const createdDate = createdAt ? moment(createdAt.toDate()).format('lll') : '';
    return createdDate;
  }

  const progressMessage = (element) => {  
    let msg = '';
    if(!element) { return ''; }  
    const { message } = element || {};  
    if(message && message.length > 0) {
      msg += message;
    }
    
    return msg;
  } 

  const progressDate = (element) => {
    if(!element) { return ''; }  
    const { createdAt } = element || { }; 
    const createdDate = createdAt ? moment(createdAt.toDate()).format('lll') : '';
    return createdDate;
  }


  return (
    <Timeline pending={null} mode='right'>
      {progressCollection.map((progress, index) => (
        <Timeline.Item key={index} color={dotColor(progress)} dot={dotIcon(progress, isSpin(index))} label={progressDate(progress)}>
          <p style={{ margin: '0px', fontWeight: isAdmin ? 'bold' : 'normal' }}>
            {progressMessage(progress)}
          </p>
          {isAdmin && (
            <p style={{ margin: '0px', fontSize: '12px', color: '#666' }}>
              {progress.info || ''}
            </p>
          )}
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export const WithdrawalProgressListView = ({ clientId, withdrawalId, isAdmin = false }) => {
  const [progressCollection, progressLoading] = useProgressCollection('withdrawals', clientId, withdrawalId);
  const [withdrawal, withdrawalLoading] = useWithdrawalDetails(clientId, withdrawalId);

  const isLoading = progressLoading || withdrawalLoading;

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '10px', color: '#666' }}>Loading progress...</p>
      </div>
    );
  }

  return (
    <ProgressListView 
      progressCollection={progressCollection} 
      item={withdrawal} 
      shouldUseDate={isAdmin} 
      isAdmin={isAdmin}
    />
  );
};

const PayoutProgressListView = ({ clientId, payoutId, isAdmin = false }) => {
  const [progressCollection, progressLoading] = useProgressCollection('payouts', clientId, payoutId);
  const [payout, payoutLoading] = usePayoutDetails(clientId, payoutId);

  const isLoading = progressLoading || payoutLoading;

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
        <p style={{ marginTop: '10px', color: '#666' }}>Loading progress...</p>
      </div>
    );
  }

  return (
    <ProgressListView 
      progressCollection={progressCollection} 
      item={payout} 
      shouldUseDate={isAdmin}
      isAdmin={isAdmin}
    />
  );
};

export default PayoutProgressListView;
